import React , {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle, Container, Modal, Button} from "reactstrap";
import { Link } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, Alert
  } from "reactstrap";

import Calendar from "rc-year-calendar";
import axios from 'axios';
import { Config, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from '../../helpers/url_helper';
import * as be from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import BootstrapTheme from "@fullcalendar/bootstrap";
import "@fullcalendar/bootstrap/main.css";


    const PPMCalendar = () => {
        const history = useHistory()
        const [events, setEvents] = useState([]);
        const [calDetails, setCalDetails] = useState([]);
        const [selectedDate, setSelectedDate] = useState('');
        const [ppmList, setPPMList] = useState([]);
        const [isloading, setIsloading] = useState(false)
        const [modal_period, setmodal_period] = useState(false);
        const [modal_ppm, setmodal_ppm] = useState(false)
        const [modal_schedule, setmodal_schedule] = useState(false)
        const [more_Menu, setmore_Menu] = useState(false);
        const [periodList, setPeriodList] = useState([])
        const [periodName, setPeriodName] = useState('')
        const [dateRange, setDateRange] = useState([])
        const [startDate, setStartDate] = useState([new Date()])
        const [endDate, setEndDate] = useState([new Date()])
        const [startPDate, setStartPDate] = useState([new Date()])
        const [endPDate, setEndPDate] = useState([new Date()])
        const [ppmTypes, setPPMTypes] = useState(['PPM - B', 'PPM - C', 'PPM - D'])
        const [userId, setUserId] = useState('')
        const [status, setStatus] = useState('')

        const [areas, setAreas] = useState([]);
        const [schemes, setSchemes] = useState([]);
        const [facilities, setFacilities] = useState([]);

        const [areaName, setAreaName] = useState('')
        const [areaId, setAreaId] = useState('')
  
        const [schemeName, setSchemeName] = useState('')
        const [schemeId, setSchemeId] = useState('')
  
        const [facilityName, setFacilityName] = useState('')
        const [facilityId, setFacilityId] = useState('')

        const [periodId, setPeriodId] = useState('')
        const [ppmType, setPPMType] = useState('')

        const [isEdit, setIsEdit] = useState(false)
        const [scheduleId, setScheduleId] = useState('')
        const [jTitle, setJTitle] = useState('')

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_period = () => {
          setmodal_period(!modal_period);
          removeBodyCss();
        }
        const tog_ppm = () => {
            setmodal_ppm(!modal_ppm);
            removeBodyCss();
        }
        const tog_schedule = () => {
            setmodal_schedule(!modal_schedule);
            removeBodyCss();
        }
        const handleGetSchemesInArea = (a) => {
            setSchemes([])
            axios.get(url.SCHEME+"?area?"+a, Config).then((r)=>{ setSchemes(r.data);  }).catch((e)=>{  console.log(e); });
          }
        const handleGetFacilitiesInScheme = (s) =>{
            setFacilities([])  
            axios.get(url.FACILITIES+"?scheme?"+s, Config).then((r)=>{ setFacilities(r.data);  }).catch((e)=>{  console.log(e); });
        }
        const handleCreateWO = () =>{
            setIsloading(true)
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            const data = {
                id              : scheduleId,
                facilityId      : facilityId,
                details         : jTitle,
                requestedById   : obj.id,
                requestedByName : obj.username
            }
            axios.post(url.CREATEPPMWO, JSON.stringify(data), Config).then((r)=>{
                console.log(r)
                setIsloading(false)
                if(r.data.status == 1){
                    history.push(`/WorkOrder-Details/${be.encryptId(r.data.is)}`)
                }
                toastr.warning(r.data.message)
            }).catch((e)=>{
                setIsloading(false)
                console.log(e)
            })
        }
        const handleSavePPM = () =>{
            let data = {}
            if(isEdit){
                data = {
                    id          : scheduleId,
                    periodId    : "",
                    facilityId  : facilityId,
                    ppmType     : ppmType,
                    dateFrom    : formatDate(startPDate[0]),
                    dateTo      : formatDate(endPDate[0]),
                    userId      : userId,
                    action      : 'edit'
                }
            }else{
                data = {
                    periodId    : "",
                    facilityId  : facilityId,
                    ppmType     : ppmType,
                    dateFrom    : formatDate(startPDate[0]),
                    dateTo      : formatDate(endPDate[0]),
                    userId      : userId,
                    action      : 'add'
                }
            }
            setIsloading(true)
            axios.post(url.PPMSCHEDULE, JSON.stringify(data), Config).then((r)=>{
                toastr.warning(r.data.message)
                setIsloading(false)
                tog_schedule()
                setStartPDate([ new Date()])
                setEndPDate([ new Date()])
                setFacilityId('')
                getData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleDeletePPM = () =>{
            let data = {
                id          : scheduleId,
                periodId    : "",
                facilityId  : facilityId,
                ppmType     : ppmType,
                dateFrom    : formatDate(startPDate[0]),
                dateTo      : formatDate(endPDate[0]),
                userId      : userId,
                action      : "delete"
            }
            setIsloading(true)
            axios.post(url.PPMSCHEDULE, JSON.stringify(data), Config).then((r)=>{ 
                toastr.warning(r.data.message)
                setIsloading(false)
                tog_schedule()
                setStartPDate([ new Date()])
                setEndPDate([ new Date()])
                setFacilityId('')
                getData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        toastr.options = {
            preventDuplicates: true,
            positionClass: "toast-top-center",
            closeButton: true,
            newestOnTop: true,
            autoClose: 45000,
            pauseOnHover: true,
            draggable: true
        }
        const getData = () => {
            axios.get(url.AREAS, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
            axios.get(url.SCHEME, Config).then((r)=>{ setSchemes(r.data); }).catch((e)=>{  console.log(e); });
            axios.get(url.FACILITIES, Config).then((r)=>{  setFacilities(r.data);}).catch((e)=>{  console.log(e); });
            axios.get(url.PPMPERIOD, Config).then((r)=>{ setPeriodList(r.data); }).catch((e)=>{  console.log(e);  });
            axios.get(url.PPMSCHEDULE, Config).then((r)=>{  
                let ev = []
                r.data.map((d)=>{
                  let classn = ''
                  if(d.task == 'PPM - A'){
                    classn = 'bg-secondary text-white' 
                  }else if(d.task == 'PPM - B'){ 
                    classn = 'bg-primary text-white' 
                  }else if(d.task == 'PPM - C'){
                    classn = 'bg-warning text-black' 
                  }else if(d.task == 'PPM - D'){
                    classn = 'bg-danger text-white' 
                  }
                  ev.push({
                    id: d.id, 
                    title:  d.task +' at '+ d.facilityName,
                    className: classn, 
                    start:d.dateFrom, 
                    end: d.dateTo ,
                    customData: { id:d.id, task: d.task, facilityId: d.facilityId, facilityName: d.facilityName, schemeId: d.schemeId, areaId: d.areaId, periodId: d.periodId, ppmType: d.task, status: d.status}
                  })
                })
                setEvents(ev)
            }).catch((e)=>{ console.log(e);  });
            if (localStorage.getItem("authWTUser")) {
                const obj = JSON.parse(localStorage.getItem("authWTUser"))
                setUserId(obj.id)
            }
        }

        useEffect(() => {
            getData();
        }, []);
        
       
        const handleEventClick1 = (eventInfo) => {
            setIsEdit(true)
            setJTitle(eventInfo.event.title)
            setAreaId(eventInfo.event.extendedProps.customData.areaId)
            setSchemeId(eventInfo.event.extendedProps.customData.schemeId)
            setFacilityId(eventInfo.event.extendedProps.customData.facilityId)
            setPeriodId(eventInfo.event.extendedProps.customData.periodId)
            setPPMType(eventInfo.event.extendedProps.customData.ppmType)
            setStartPDate([new Date(eventInfo.event.start)])
            setEndPDate([new Date(eventInfo.event.end)])
            setScheduleId(eventInfo.event.extendedProps.customData.id)
            setStatus(eventInfo.event.extendedProps.customData.status)
            tog_schedule()
          };
        const handleSavePeriod = () =>{
            const data = {
                period      : periodName,
                startDate   : formatDate(startDate[0]),
                endDate     : formatDate(endDate[0]),
                userId      : userId,
                action      : "add"
            }
            setIsloading(true)
            axios.post(url.PPMPERIOD, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    tog_period()
                    setDateRange([])
                    setPeriodName('')
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>PPM Schedule | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        
                                <Modal isOpen={modal_schedule} toggle={() => { tog_schedule(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Planned Preventive Maintenance`:`Schedule PPM`}</h5>
                                    <button type="button"  onClick={() => { setmodal_schedule(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row> 
                                 
                                  <Col md={12}>
                                      <div className="mb-3">
                                            <label>Area</label>
                                            <select className="form-select"  value={areaId} onChange={(e)=>{setAreaId(e.target.value); handleGetSchemesInArea(e.target.value)}}>
                                            <option value=""></option>
                                            {areas.map((r,k)=>(<option key={k} value={r.id}>{r.name}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                 
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Scheme</label>
                                            <select className="form-select"  value={schemeId} onChange={(e)=>{setSchemeId(e.target.value); handleGetFacilitiesInScheme(e.target.value)}} >
                                            <option value=""></option>
                                            {schemes.map((r,k)=>(<option key={k} value={r.id}>{r.scheme}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Facility</label>
                                            <select className="form-select"  value={facilityId} onChange={(e)=>{setFacilityId(e.target.value);}}>
                                            <option value=""></option>
                                            {facilities.map((f,k)=>(<option key={k} value={f.id}>{f.facility}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>PPM type</label>
                                        <select className="form-select" value={ppmType} onChange={(e)=>setPPMType(e.target.value)}>
                                        <option value=""> </option>
                                        {ppmTypes.map((p,k)=>(
                                                <option key={k} value={p}>{p}</option>
                                            )
                                        )}
                                            </select>
                                        
                                        </div>
                                    </Col>  
                                    <Col md={6}>
                                    <div className="mb-3">
                                        <label>Start date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={startPDate}
                                                onChange={(dates)=>setStartPDate(dates)}
                                            /> 
                                        </div>
                                    </Col>  
                                    <Col md={6}>
                                    <div className="mb-3">
                                        <label>End date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={endPDate}
                                                onChange={(dates)=>setEndPDate(dates)}
                                            /> 
                                        </div>
                                    </Col>                                
                                  </Row>
                                
                                  </div>
                                  {(status != 'Assigned') && 
                                    	(<div className="modal-footer justify-content-center">
                                    {(isloading ? 
                                            (<Alert>Please wait...</Alert>)
                                        : ( <>{isEdit && <> <button type="button" className="btn btn-danger" onClick={handleDeletePPM}>Delete...</button>
                                                            <button type="button" className="btn btn-success" onClick={handleCreateWO}>Create PPM Work Order...</button></>}
                                        <button type="button" className="btn btn-primary" onClick={handleSavePPM}>Save PPM Schedule...</button></> )
                                    )}
                                  </div>)}
                                </Modal>
    


                        <Row>
                        <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Create PPM Schedule</h5>
                               <CardBody>
                               <Row>
                               <Col lg="12">
                                    
                                    <div className="d-grid gap-2">
                                    <button type="button" className="btn btn-primary" onClick={()=>{setIsEdit(false); setFacilityId(''); tog_schedule()}}>Schedule Planned Maintenance...</button>
                                    
                                    </div>
                                
                                </Col>
                               </Row>
                               

                               </CardBody>
                            </Card>
                        </Col>
                        <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">PPM Calendar</h5>
                               
                                <CardBody>
                                <Row>
                                    <Col lg="12">
                                  
                                    <FullCalendar
          
                                        plugins={[
                                            BootstrapTheme,
                                            dayGridPlugin,
                                            interactionPlugin
                                        ]}
                                        slotDuration={"00:15:00"}
                                        handleWindowResize={true}
                                        themeSystem="bootstrap"
                                        headerToolbar={{
                                            left: "prev,next today",
                                            center: "title",
                                            right: "dayGridMonth,dayGridWeek,dayGridDay",
                                        }}
                                        events={events}
                                        selectable={true}
                                        //dateClick={handleDateClick}
                                        eventClick={handleEventClick1}
                                        //drop={onDrop}
                                        />                       
                                    </Col>
                                </Row>
                                </CardBody>
                                </Card>
                                </Col>
                        
                        </Row>
                    </Container>
                </div>
            </>
        );
    }

export default PPMCalendar;